import { Maybe } from 'graphql/jsutils/Maybe';
import { isNil } from 'lodash';

export const isNotNil = <T>(v: Maybe<T>): v is T => {
  return !isNil(v);
};
